export class SingleEventSource extends EventSource {
  // properties
  private static _instance: SingleEventSource | null = null;
  // methods
  static create(url: string | URL, eventSourceInitDict?: EventSourceInit) {
    const eventSource =
      SingleEventSource._instance ||
      (SingleEventSource._instance = new SingleEventSource(
        url,
        eventSourceInitDict,
      ));
    return eventSource;
  }
  // methods
  destroy() {
    if (SingleEventSource._instance) {
      SingleEventSource._instance.close();
    }
    SingleEventSource._instance = null;
  }
}
